class DenimSizingUI {
  constructor(containerSelector = '#denim-sizing-container') {
    this.container = document.querySelector(containerSelector);
    if (!this.container) return;

    this.closeBtn = this.container.querySelector('#close-denim');
    this.init();
  }

  init() {
    this.handleClose();
    this.handleTabs();
    this.handleUnitToggles();
    this.handleSizeSelection();
    this.handleMeasureButtons();
  }

  handleClose() {
    if (!this.closeBtn) return;
    this.closeBtn.addEventListener('click', () => {
      this.container.classList.remove('is-open');
    });
  }

  handleTabs() {
    const tabs = this.container.querySelectorAll('.page-tab');
    const sections = this.container.querySelectorAll('.denim-sizing-section');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const index = tab.dataset.index;

        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        sections.forEach(section => {
          section.classList.remove('active');
          if (section.dataset.index === index) {
            section.classList.add('active');
          }
        });
      });
    });
  }

handleUnitToggles() {
  const toggleInput = this.container.querySelector('#unit-toggle');
  const measurementGroups = this.container.querySelectorAll('.size-type-measurements');

  if (!toggleInput) return;

  toggleInput.addEventListener('change', () => {
    const index = toggleInput.checked ? '1' : '0';

    toggleInput.setAttribute('aria-checked', toggleInput.checked ? 'true' : 'false');

    measurementGroups.forEach(group => {
      group.classList.remove('active');
      if (group.dataset.index === index) {
        group.classList.add('active');
      }
    });
  });
}


  handleSizeSelection() {
  const sizeButtons = this.container.querySelectorAll('.measure-size');
  const valueSets = this.container.querySelectorAll('.measure-size-values');

  sizeButtons.forEach(button => {
    button.addEventListener('click', () => {
      const index = button.dataset.index;

      // Update all size buttons
      sizeButtons.forEach(btn => {
        btn.classList.remove('active');
        btn.classList.remove('link--underline');
        btn.setAttribute('aria-selected', 'false');
      });

      // Activate clicked button
      button.classList.add('active');
      button.classList.add('link--underline');
      button.setAttribute('aria-selected', 'true');

      // Update matching size values
      valueSets.forEach(set => {
        set.classList.remove('active');
        if (set.dataset.index === index) {
          set.classList.add('active');
        }
      });
    });
  });
}



  handleMeasureButtons() {
    const section = this.container.querySelector('.denim-sizing-section.measure');
    if (!section) return;

    const buttons = section.querySelectorAll('.measure-button');
    const infos = section.querySelectorAll('.measure-info');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const index = button.dataset.index;

        buttons.forEach(b => b.classList.remove('active'));
        button.classList.add('active');

        infos.forEach(info => {
          info.classList.remove('active');
          if (info.dataset.index === index) {
            info.classList.add('active');
          }
        });
      });
    });
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  new DenimSizingUI();
});
